export default {
    covariate_2: 'Legality of Abortion',
    covariate_3: 'Absolute value of average latitude',
    covariate_5: 'Adult HIV death rate',
    covariate_6: 'Alcohol (liters per capita)',
    covariate_7: 'Antenatal Care (1 visit) Coverage (proportion)',
    covariate_8: 'Antenatal Care (4 visits) Coverage (proportion)',
    covariate_11: 'Asbestos production (binary)',
    covariate_12: 'Asbestos production (kg) per capita',
    covariate_13: 'Age-Specific Fertility Rate',
    covariate_14: 'Tobacco (cigarettes per capita)',
    covariate_15: 'Coal Production (per capita)',
    covariate_16: 'Coastal Population within 10km (proportion)',
    covariate_18: 'Contraception (Modern) Prevalence (proportion by age)',
    covariate_19: 'Contraception (Modern) Prevalence (proportion)',
    covariate_24: 'Cumulative Cigarettes (10 Years)',
    covariate_25: 'Cumulative Cigarettes (15 Years)',
    covariate_26: 'Cumulative Cigarettes (20 Years)',
    covariate_27: 'Cumulative Cigarettes (5 Years)',
    covariate_28: 'Diabetes Fasting Plasma Glucose (mmol/L), age-standardized 25+',
    covariate_29: 'Diabetes Age-Standardized Prevalence (proportion)',
    covariate_30: 'Diabetes Age-Specific Prevalence (proportion)',
    covariate_32: 'DTP3 Coverage (proportion)',
    covariate_33: 'Education (years per capita)',
    covariate_39: 'Female HIV death rate per 1 for ages 15-49',
    covariate_42: 'Gold production (binary)',
    covariate_43: 'Gold production (kg) per capita',
    covariate_44: 'Health System Access (unitless)',
    covariate_45: 'Health System Access 2 (unitless)',
    covariate_46: 'Proportion of households using iodized salt (adjusted)',
    covariate_47: 'Hib3 Vaccine Coverage (proportion)',
    covariate_49: 'HIV Prevalence Unadjusted (proportion)',
    covariate_50: 'Hospital Beds (per 1000)',
    covariate_51: 'In-Facility Delivery (proportion)',
    covariate_55: 'Landlocked Nation (binary)',
    covariate_56: 'Average latitude',
    covariate_57: 'LDI (I$ per capita)',
    covariate_58: 'Lead Gas Outphase (binary)',
    covariate_60: 'Live Births (thousands)',
    covariate_66: 'Underweight (proportion <2SD weight for age, <5 years)',
    covariate_68: 'Mean BMI',
    covariate_69: 'Cholesterol (total, mean per capita)',
    covariate_70: 'Systolic Blood Pressure (mmHg)',
    covariate_71: 'Population-weighted mean temperature',
    covariate_75: 'Measles Vaccine Coverage (proportion)',
    covariate_79: 'Mortality Rate Due to Death Shocks in Last 10 Years (per 1 person)',
    covariate_82: 'Opium Cultivation (binary)',
    covariate_84: 'Live Births 35+ (proportion)',
    covariate_85: 'Live Births 40+ (proportion)',
    covariate_99: 'Pig Meat (kg per capita)',
    covariate_100: 'Pigs (per capita)',
    covariate_105: 'Indoor Air Pollution (All Cooking Fuels)',
    covariate_106: 'Outdoor Air Pollution (PM2.5)',
    covariate_107: 'Latitude Under 15 (proportion)',
    covariate_108: 'Elevation 100 to 500m (proportion)',
    covariate_109: 'Elevation Over 1500m (proportion)',
    covariate_110: 'Population 15 to 30 (proportion)',
    covariate_111: 'Latitude 15 to 30 (proportion)',
    covariate_112: 'Latitude 30 to 45 (proportion)',
    covariate_113: 'Latitude Over 45 (proportion)',
    covariate_114: 'Elevation 500 to 1500m (proportion)',
    covariate_115: 'Population Density (150-300 ppl/sqkm, proportion)',
    covariate_116: 'Population Density (300-500 ppl/sqkm, proportion)',
    covariate_117: 'Population Density (500-1000 ppl/sqkm, proportion)',
    covariate_118: 'Population Density (over 1000 ppl/sqkm, proportion)',
    covariate_119: 'Population Density (under 150 ppl/sqkm, proportion)',
    covariate_120: 'Population Over 65 (proportion)',
    covariate_121: 'Elevation Under 100m (proportion)',
    covariate_127: 'Rainfall Population-Weighted (mm/yr)',
    covariate_128: 'Rainfall (Quintiles 2-5)',
    covariate_129: 'Rainfall (Quintiles 3-5)',
    covariate_130: 'Rainfall (Quintiles 4-5)',
    covariate_131: 'Rainfall Quintile 1 (proportion)',
    covariate_132: 'Rainfall Quintile 2 (proportion)',
    covariate_133: 'Rainfall Quintile 3 (proportion)',
    covariate_134: 'Rainfall Quintile 4 (proportion)',
    covariate_135: 'Rainfall Quintile 5 (proportion)',
    covariate_137: 'Religion (binary, >50% Muslim)',
    covariate_141: 'Sahel Region of Africa (binary)',
    covariate_142: 'Sanitation (proportion with access)',
    covariate_143: 'Skilled Birth Attendance (proportion)',
    covariate_145: 'Smoking Prevalence',
    covariate_146: 'Smoking Prevalence (Reproductive Age Standardized)',
    covariate_147: '90th percentile climatic temperature in the given country-year.',
    covariate_148: 'Tetanus Toxoid Coverage Smooth (proportion)',
    covariate_149: 'Total Fertility Rate',
    covariate_154: 'Vehicles - 2+4 wheels (per capita)',
    covariate_155: 'Vehicles - 2 wheels (per capita)',
    covariate_156: 'Vehicles - 4 wheels (per capita)',
    covariate_157: 'Vehicles - 2 wheels fraction (proportion)',
    covariate_159: 'Mortality Rate Due to War Shocks (per 1 person)',
    covariate_160: 'Improved Water Source (proportion with access)',
    covariate_183: 'Malaria Lysenko PFPR 1 (Holoendemic)',
    covariate_184: 'Malaria Lysenko PFPR (2 Highest Endemicity)',
    covariate_188: 'Malaria PFPR (rate)',
    covariate_192: 'Significant leishmaniasis endemicity (binary)',
    covariate_193: 'Leprosy endemic (binary)',
    covariate_195: 'Year',
    covariate_196: 'Chagas Population-at-Risk 2 (proportion)',
    covariate_197: 'Birth prevalence of CHD',
    covariate_198: 'Birth prevalence of congenital chromosomal anomalies',
    covariate_200: 'Hemoglobinopathies Prevalence x Excess Mortality',
    covariate_205: 'Age-Standardize Prevalence of Severe Anemia',
    covariate_206: 'Schistosomiasis Prevalence (proportion)',
    covariate_208: 'Maternal care and immunization',
    covariate_209: 'Neonatal Mortality Rate Modeled 2 (per 1000)',
    covariate_210: 'PCV3 Coverage (proportion)',
    covariate_211: 'Presence of leishmaniasis (binary)',
    covariate_212: 'Potential for leishmaniasis transmission (binary)',
    covariate_213: 'High leishmaniasis endemicity (binary)',
    covariate_214: 'Under 5 HIV death rate',
    covariate_215: 'Interaction of malaria ITN and PFPR rate covariates',
    covariate_216: 'Interaction of malaria ITN and log PFPR covariates',
    covariate_217: 'Malaria PFPR adjusted for ITN and IRS coverage',
    covariate_218: 'Syphilis prevalence (proportion)',
    covariate_219: 'Year * GBD analytical region 5',
    covariate_220: 'Year * GBD analytical region 9',
    covariate_221: 'Year * GBD analytical region 21',
    covariate_222: 'Year * GBD analytical region 32',
    covariate_223: 'Year * GBD analytical region 42',
    covariate_224: 'Year * GBD analytical region 56',
    covariate_225: 'Year * GBD analytical region 65',
    covariate_226: 'Year * GBD analytical region 70',
    covariate_227: 'Year * GBD analytical region 73',
    covariate_228: 'Year * GBD analytical region 96',
    covariate_229: 'Year * GBD analytical region 100',
    covariate_230: 'Year * GBD analytical region 104',
    covariate_231: 'Year * GBD analytical region 120',
    covariate_232: 'Year * GBD analytical region 124',
    covariate_233: 'Year * GBD analytical region 134',
    covariate_234: 'Year * GBD analytical region 138',
    covariate_235: 'Year * GBD analytical region 159',
    covariate_236: 'Year * GBD analytical region 167',
    covariate_237: 'Year * GBD analytical region 174',
    covariate_238: 'Year * GBD analytical region 192',
    covariate_239: 'Year * GBD analytical region 199',
    covariate_240: 'Year * GBD analytical superregion 4',
    covariate_241: 'Year * GBD analytical superregion 31',
    covariate_242: 'Year * GBD analytical superregion 64',
    covariate_243: 'Year * GBD analytical superregion 103',
    covariate_244: 'Year * GBD analytical superregion 137',
    covariate_245: 'Year * GBD analytical superregion 158',
    covariate_246: 'Year * GBD analytical superregion 166',
    covariate_247: 'Population weighted probability of dengue transmission',
    covariate_248: 'Dengue outbreaks (binary)',
    covariate_249: 'Exponentiated version of dengue anomalies',
    covariate_250: 'Proportion of the population living in the classic monsoon region',
    covariate_251:
        'Proportion of the population living in the classic monsoon region (low-income countries)',
    covariate_252: 'Dengue anomalies (deviation from mean dengue incidence rate)',
    covariate_255: 'Total PC treatments per person at risk for LF Infection (1999-2012)',
    covariate_256: 'Smoking Prevalence (Age-standardized, females)',
    covariate_257: 'Smoking Prevalence (Age-standardized, males)',
    covariate_260: 'Indicator for High-income superregion',
    covariate_261: 'Vitamin A supplementation coverage rate',
    covariate_262: 'Hemoglobinopathies Prevalence x Excess Mortality (excluding G6PD deficiency)',
    covariate_266: 'Indicator for Southeast Asia, East Asia, and Oceania superregion',
    covariate_267: 'Indicator for Central Europe, Eastern Europe, and Central Asia superregion',
    covariate_268: 'Indicator for Latin America and Caribbean superregion',
    covariate_269: 'Indicator for North Africa and Middle East superregion',
    covariate_270: 'Indicator for South Asia superregion',
    covariate_271: 'Indicator for Sub-Saharan Africa superregion',
    covariate_273: 'Alcohol binge drinker proportion, age-standardized',
    covariate_282: 'Smoking Prevalence (Age-standardized, both sexes)',
    covariate_441: 'Proportion of the population living in the Indian Ocean monsoon belt',
    covariate_442: 'Vitamin A Deficiency Prevalence (age-standardized)',
    covariate_453: 'Prevalence of obesity',
    covariate_454: 'Prevalence of overweight and obesity',
    covariate_455: 'Prevalence of obesity (age-standardized)',
    covariate_463: 'Maternal Education (years per capita)',
    covariate_467: 'ChagasPrevPAHO',
    covariate_479: 'Enhanced Vegetation Index long term average 2000-2012 (mean)',
    covariate_483: 'Log-transformed SEV scalar: TB',
    covariate_485: 'Log-transformed SEV scalar: Oth HIV',
    covariate_486: 'Log-transformed SEV scalar: Diarrhea',
    covariate_491: 'Log-transformed SEV scalar: LRI',
    covariate_492: 'Log-transformed SEV scalar: URI',
    covariate_493: 'Log-transformed SEV scalar: Otitis',
    covariate_494: 'Log-transformed SEV scalar: Meningitis',
    covariate_503: 'Log-transformed SEV scalar: Measles',
    covariate_526: 'Log-transformed SEV scalar: Mat Hem',
    covariate_527: 'Log-transformed SEV scalar: Mat Sepsis',
    covariate_528: 'Log-transformed SEV scalar: Mat HTN',
    covariate_530: 'Log-transformed SEV scalar: Mat Abort',
    covariate_531: 'Log-transformed SEV scalar: Mat Indir',
    covariate_532: 'Log-transformed SEV scalar: Mat Late',
    covariate_533: 'Log-transformed SEV scalar: Oth Mat',
    covariate_541: 'Log-transformed SEV scalar: Hep',
    covariate_543: 'Log-transformed SEV scalar: Hep B',
    covariate_544: 'Log-transformed SEV scalar: Hep C',
    covariate_548: 'Log-transformed SEV scalar: Esophag C',
    covariate_549: 'Log-transformed SEV scalar: Stomach C',
    covariate_550: 'Log-transformed SEV scalar: Liver C',
    covariate_551: 'Log-transformed SEV scalar: Liver C HepB',
    covariate_552: 'Log-transformed SEV scalar: Liver C HepC',
    covariate_553: 'Log-transformed SEV scalar: Oth Liver C',
    covariate_554: 'Log-transformed SEV scalar: Larynx C',
    covariate_555: 'Log-transformed SEV scalar: Lung C',
    covariate_556: 'Log-transformed SEV scalar: Breast C',
    covariate_557: 'Log-transformed SEV scalar: Uterus C',
    covariate_558: 'Log-transformed SEV scalar: Prostate C',
    covariate_559: 'Log-transformed SEV scalar: Colorect C',
    covariate_560: 'Log-transformed SEV scalar: Lip Oral C',
    covariate_561: 'Log-transformed SEV scalar: Nasoph C',
    covariate_562: 'Log-transformed SEV scalar: Oth Phar C',
    covariate_563: 'Log-transformed SEV scalar: Gallblad C',
    covariate_564: 'Log-transformed SEV scalar: Pancreas C',
    covariate_567: 'Log-transformed SEV scalar: Ovary C',
    covariate_569: 'Log-transformed SEV scalar: Kidney C',
    covariate_570: 'Log-transformed SEV scalar: Bladder C',
    covariate_572: 'Log-transformed SEV scalar: Thyroid C',
    covariate_573: 'Log-transformed SEV scalar: Mesothel',
    covariate_577: 'Log-transformed SEV scalar: Leukemia',
    covariate_579: 'Log-transformed SEV scalar: RHD',
    covariate_580: 'Log-transformed SEV scalar: IHD',
    covariate_581: 'Log-transformed SEV scalar: Stroke',
    covariate_582: 'Log-transformed SEV scalar: Isch Stroke',
    covariate_583: 'Log-transformed SEV scalar: Intrahem Stroke',
    covariate_584: 'Log-transformed SEV scalar: CMP',
    covariate_585: 'Log-transformed SEV scalar: A Fib',
    covariate_586: 'Log-transformed SEV scalar: Aort An',
    covariate_587: 'Log-transformed SEV scalar: PAD',
    covariate_588: 'Log-transformed SEV scalar: Endocar',
    covariate_589: 'Log-transformed SEV scalar: Oth Cardio',
    covariate_590: 'Log-transformed SEV scalar: COPD',
    covariate_596: 'Log-transformed SEV scalar: Asthma',
    covariate_597: 'Log-transformed SEV scalar: ILD',
    covariate_598: 'Log-transformed SEV scalar: Oth Resp',
    covariate_599: 'Log-transformed SEV scalar: Cirr HepB',
    covariate_600: 'Log-transformed SEV scalar: Cirr HepC',
    covariate_610: 'Log-transformed SEV scalar: Pancreatit',
    covariate_614: 'Log-transformed SEV scalar: Idiopathic epilepsy',
    covariate_621: 'Log-transformed SEV scalar: Depression',
    covariate_622: 'Log-transformed SEV scalar: MDD',
    covariate_625: 'Log-transformed SEV scalar: Anxiety',
    covariate_634: 'Log-transformed SEV scalar: ID',
    covariate_658: 'Log-transformed SEV scalar: Osteoarth',
    covariate_659: 'Log-transformed SEV scalar: Back+Neck',
    covariate_660: 'Log-transformed SEV scalar: Back Pain',
    covariate_662: 'Log-transformed SEV scalar: Gout',
    covariate_687: 'Log-transformed SEV scalar: Sense',
    covariate_689: 'Log-transformed SEV scalar: Cataract',
    covariate_692: 'Log-transformed SEV scalar: Hearing',
    covariate_701: 'Log-transformed SEV scalar: SIDS',
    covariate_702: 'Log-transformed SEV scalar: Road Inj',
    covariate_703: 'Log-transformed SEV scalar: Pedest',
    covariate_704: 'Log-transformed SEV scalar: Cyclist',
    covariate_705: 'Log-transformed SEV scalar: Mot Cyc',
    covariate_706: 'Log-transformed SEV scalar: Mot Veh',
    covariate_707: 'Log-transformed SEV scalar: Oth Road',
    covariate_708: 'Log-transformed SEV scalar: Oth Trans',
    covariate_709: 'Log-transformed SEV scalar: Falls',
    covariate_710: 'Log-transformed SEV scalar: Drown',
    covariate_711: 'Log-transformed SEV scalar: Fire',
    covariate_712: 'Log-transformed SEV scalar: Poison',
    covariate_713: 'Log-transformed SEV scalar: Mech',
    covariate_714: 'Log-transformed SEV scalar: Mech Gun',
    covariate_715: 'Log-transformed SEV scalar: Mech Suff',
    covariate_716: 'Log-transformed SEV scalar: Oth Mech',
    covariate_718: 'Log-transformed SEV scalar: Animal',
    covariate_719: 'Log-transformed SEV scalar: Venom',
    covariate_720: 'Log-transformed SEV scalar: Non Ven',
    covariate_721: 'Log-transformed SEV scalar: F Body',
    covariate_722: 'Log-transformed SEV scalar: F Body Asp',
    covariate_724: 'Log-transformed SEV scalar: Oth F Body',
    covariate_725: 'Log-transformed SEV scalar: Oth Unint',
    covariate_726: 'Log-transformed SEV scalar: Self Harm',
    covariate_727: 'Log-transformed SEV scalar: Violence',
    covariate_728: 'Log-transformed SEV scalar: Viol Gun',
    covariate_729: 'Log-transformed SEV scalar: Viol Knife',
    covariate_730: 'Log-transformed SEV scalar: Oth Viol',
    covariate_731: 'Log-transformed SEV scalar: Disaster',
    covariate_733: 'Log-transformed SEV scalar: Mat HIV',
    covariate_737: 'Log-transformed age-standardized SEV scalar: TB',
    covariate_739: 'Log-transformed age-standardized SEV scalar: Oth HIV',
    covariate_740: 'Log-transformed age-standardized SEV scalar: Diarrhea',
    covariate_744: 'Log-transformed age-standardized SEV scalar: LRI',
    covariate_745: 'Log-transformed age-standardized SEV scalar: URI',
    covariate_746: 'Log-transformed age-standardized SEV scalar: Otitis',
    covariate_747: 'Log-transformed age-standardized SEV scalar: Measles',
    covariate_748: 'Log-transformed age-standardized SEV scalar: Mat Hem',
    covariate_749: 'Log-transformed age-standardized SEV scalar: Mat Sepsis',
    covariate_750: 'Log-transformed age-standardized SEV scalar: Mat Abort',
    covariate_751: 'Log-transformed age-standardized SEV scalar: Hep',
    covariate_752: 'Log-transformed age-standardized SEV scalar: Hep B',
    covariate_753: 'Log-transformed age-standardized SEV scalar: Hep C',
    covariate_754: 'Log-transformed age-standardized SEV scalar: Esophag C',
    covariate_755: 'Log-transformed age-standardized SEV scalar: Stomach C',
    covariate_756: 'Log-transformed age-standardized SEV scalar: Liver C',
    covariate_757: 'Log-transformed age-standardized SEV scalar: Liver C HepB',
    covariate_758: 'Log-transformed age-standardized SEV scalar: Liver C HepC',
    covariate_759: 'Log-transformed age-standardized SEV scalar: Oth Liver C',
    covariate_760: 'Log-transformed age-standardized SEV scalar: Larynx C',
    covariate_761: 'Log-transformed age-standardized SEV scalar: Lung C',
    covariate_762: 'Log-transformed age-standardized SEV scalar: Breast C',
    covariate_763: 'Log-transformed age-standardized SEV scalar: Uterus C',
    covariate_764: 'Log-transformed age-standardized SEV scalar: Prostate C',
    covariate_765: 'Log-transformed age-standardized SEV scalar: Colorect C',
    covariate_766: 'Log-transformed age-standardized SEV scalar: Lip Oral C',
    covariate_767: 'Log-transformed age-standardized SEV scalar: Nasoph C',
    covariate_768: 'Log-transformed age-standardized SEV scalar: Oth Phar C',
    covariate_769: 'Log-transformed age-standardized SEV scalar: Gallblad C',
    covariate_770: 'Log-transformed age-standardized SEV scalar: Pancreas C',
    covariate_771: 'Log-transformed age-standardized SEV scalar: Ovary C',
    covariate_772: 'Log-transformed age-standardized SEV scalar: Kidney C',
    covariate_773: 'Log-transformed age-standardized SEV scalar: Bladder C',
    covariate_774: 'Log-transformed age-standardized SEV scalar: Thyroid C',
    covariate_775: 'Log-transformed age-standardized SEV scalar: Mesothel',
    covariate_776: 'Log-transformed age-standardized SEV scalar: Leukemia',
    covariate_777: 'Log-transformed age-standardized SEV scalar: RHD',
    covariate_778: 'Log-transformed age-standardized SEV scalar: IHD',
    covariate_779: 'Log-transformed age-standardized SEV scalar: Stroke',
    covariate_780: 'Log-transformed age-standardized SEV scalar: Isch Stroke',
    covariate_781: 'Log-transformed age-standardized SEV scalar: Intrahem Stroke',
    covariate_782: 'Log-transformed age-standardized SEV scalar: CMP',
    covariate_783: 'Log-transformed age-standardized SEV scalar: A Fib',
    covariate_784: 'Log-transformed age-standardized SEV scalar: Aort An',
    covariate_785: 'Log-transformed age-standardized SEV scalar: PAD',
    covariate_786: 'Log-transformed age-standardized SEV scalar: Endocar',
    covariate_787: 'Log-transformed age-standardized SEV scalar: Oth Cardio',
    covariate_788: 'Log-transformed age-standardized SEV scalar: COPD',
    covariate_794: 'Log-transformed age-standardized SEV scalar: Asthma',
    covariate_796: 'Log-transformed age-standardized SEV scalar: Oth Resp',
    covariate_797: 'Log-transformed age-standardized SEV scalar: Cirr HepB',
    covariate_798: 'Log-transformed age-standardized SEV scalar: Cirr HepC',
    covariate_800: 'Log-transformed age-standardized SEV scalar: Pancreatit',
    covariate_801: 'Log-transformed age-standardized SEV scalar: Idiopathic epilepsy',
    covariate_802: 'Log-transformed age-standardized SEV scalar: Depression',
    covariate_803: 'Log-transformed age-standardized SEV scalar: MDD',
    covariate_805: 'Log-transformed age-standardized SEV scalar: ID',
    covariate_806: 'Log-transformed age-standardized SEV scalar: Osteoarth',
    covariate_807: 'Log-transformed age-standardized SEV scalar: Back+Neck',
    covariate_808: 'Log-transformed age-standardized SEV scalar: Back Pain',
    covariate_809: 'Log-transformed age-standardized SEV scalar: Gout',
    covariate_810: 'Log-transformed age-standardized SEV scalar: Sense',
    covariate_811: 'Log-transformed age-standardized SEV scalar: Cataract',
    covariate_812: 'Log-transformed age-standardized SEV scalar: Hearing',
    covariate_813: 'Log-transformed age-standardized SEV scalar: Road Inj',
    covariate_814: 'Log-transformed age-standardized SEV scalar: Pedest',
    covariate_815: 'Log-transformed age-standardized SEV scalar: Cyclist',
    covariate_816: 'Log-transformed age-standardized SEV scalar: Mot Cyc',
    covariate_817: 'Log-transformed age-standardized SEV scalar: Mot Veh',
    covariate_818: 'Log-transformed age-standardized SEV scalar: Oth Road',
    covariate_819: 'Log-transformed age-standardized SEV scalar: Oth Trans',
    covariate_820: 'Log-transformed age-standardized SEV scalar: Falls',
    covariate_821: 'Log-transformed age-standardized SEV scalar: Drown',
    covariate_822: 'Log-transformed age-standardized SEV scalar: Fire',
    covariate_823: 'Log-transformed age-standardized SEV scalar: Poison',
    covariate_824: 'Log-transformed age-standardized SEV scalar: Mech',
    covariate_825: 'Log-transformed age-standardized SEV scalar: Mech Gun',
    covariate_826: 'Log-transformed age-standardized SEV scalar: Mech Suff',
    covariate_827: 'Log-transformed age-standardized SEV scalar: Oth Mech',
    covariate_828: 'Log-transformed age-standardized SEV scalar: Animal',
    covariate_829: 'Log-transformed age-standardized SEV scalar: Venom',
    covariate_830: 'Log-transformed age-standardized SEV scalar: Non Ven',
    covariate_831: 'Log-transformed age-standardized SEV scalar: F Body',
    covariate_832: 'Log-transformed age-standardized SEV scalar: F Body Asp',
    covariate_834: 'Log-transformed age-standardized SEV scalar: Oth F Body',
    covariate_835: 'Log-transformed age-standardized SEV scalar: Oth Unint',
    covariate_836: 'Log-transformed age-standardized SEV scalar: Self Harm',
    covariate_837: 'Log-transformed age-standardized SEV scalar: Violence',
    covariate_838: 'Log-transformed age-standardized SEV scalar: Viol Gun',
    covariate_839: 'Log-transformed age-standardized SEV scalar: Viol Knife',
    covariate_840: 'Log-transformed age-standardized SEV scalar: Oth Viol',
    covariate_845: 'Education age-standardized',
    covariate_848: 'Meningitis belt (proportion)',
    covariate_851: 'GDP per capita base 2010 ',
    covariate_854: 'Urbanicity',
    covariate_863: 'Age- and sex-specific SEV for Unsafe water',
    covariate_866: 'Age- and sex-specific SEV for Unsafe sanitation',
    covariate_869: 'Malaria incidence - from MAP estimates(AFRICA)',
    covariate_872:
        'Dengue Reporting Trends (transformed into relative risks, relative to that country’s mean incidence)',
    covariate_875: 'Echinococcosis endemicity ',
    covariate_881: 'Socio-demographic Index',
    covariate_884: 'Japanese encelphalitis endemic area (binary)',
    covariate_887: 'Calcium adjusted(g)',
    covariate_890: 'Calcium unadjusted(g)',
    covariate_899: 'Fiber adjusted(g)',
    covariate_902: 'Fiber unadjusted(g)',
    covariate_905: 'Omega 3 adjusted(g)',
    covariate_911: 'Fruits adjusted(g)',
    covariate_914: 'Fruits unadjusted(g)',
    covariate_917: 'Milk adjusted(g)',
    covariate_920: 'Milk unadjusted(g)',
    covariate_923: 'Nuts seeds adjusted(g)',
    covariate_926: 'Nuts seeds unadjusted(g)',
    covariate_929: 'Pufa adjusted(percent)',
    covariate_932: 'Pulses legumes adjusted(g)',
    covariate_935: 'Pulses legumes unadjusted(g)',
    covariate_938: 'Red meats adjusted(g)',
    covariate_941: 'Red meats unadjusted(g)',
    covariate_950: 'Saturated fats adjusted(percent)',
    covariate_959: 'Sugar adjusted(g)',
    covariate_962: 'Sugar unadjusted(g)',
    covariate_965: 'Vegetables adjusted(g)',
    covariate_968: 'Vegetables unadjusted(g)',
    covariate_977: 'Energy unadjusted(kcal)',
    covariate_980: 'Interaction of prevalence weighted drug resistance and malaria incidence',
    covariate_986: 'HIV mortality, females, 10-54',
    covariate_1016: 'HIV age-standardized prevalence',
    covariate_1019: 'Log-transformed age-standardized SEV scalar: Maternal',
    covariate_1022: 'Log-transformed age-standardized SEV scalar: CVD',
    covariate_1025: 'Log-transformed age-standardized SEV scalar: Chr Resp',
    covariate_1028: 'Log-transformed age-standardized SEV scalar: Cirrhosis',
    covariate_1031: 'Log-transformed age-standardized SEV scalar: Digestive',
    covariate_1034: 'Log-transformed age-standardized SEV scalar: MSK',
    covariate_1037: 'Log-transformed age-standardized SEV scalar: Trans Inj',
    covariate_1040: 'Log-transformed SEV scalar: Maternal',
    covariate_1043: 'Log-transformed SEV scalar: CVD',
    covariate_1046: 'Log-transformed SEV scalar: Chr Resp',
    covariate_1049: 'Log-transformed SEV scalar: Cirrhosis',
    covariate_1052: 'Log-transformed SEV scalar: Digestive',
    covariate_1055: 'Log-transformed SEV scalar: MSK',
    covariate_1058: 'Log-transformed SEV scalar: Trans Inj',
    covariate_1062: 'Vitamin a unadjusted (iu)',
    covariate_1063: 'Vitamin a rae unadjusted (ug)',
    covariate_1064: 'Vitamin a retinol unadjusted (ug)',
    covariate_1065: 'Dietary zinc unadjusted (mg)',
    covariate_1068:
        'Proportion of total population covered by menafrivac initiative (meningitis meningococcal type A vaccine)',
    covariate_1069: 'Stunting (proportion <2SD height for age, <5 years)',
    covariate_1070: 'Wasting (proportion <2SD weight for height, <5 years)',
    covariate_1071: 'Malnutrition (childhood underweight, proportion <2SD weight for age)',
    covariate_1072: 'Malaria incidence adjusted for antimalarial coverage and drug effectiveness',
    covariate_1073: 'Hepatitis B (HBsAg) Seroprevalence',
    covariate_1074: 'Hepatitis C (IgG) Seroprevalence',
    covariate_1075: 'Rotavirus coverage (proportion)',
    covariate_1076: 'Proportion of cirrhosis due to alcohol ',
    covariate_1077: 'Proportion of cirrhosis due to hepatitis B',
    covariate_1078: 'Proportion of cirrhosis due to hepatitis C',
    covariate_1079: 'Proportion of cirrhosis due to other causes',
    covariate_1080: 'Proportion of liver cancer due to alcohol (Age Standardized)',
    covariate_1081: 'Proportion of liver cancer due to hepatitis B (Age Standardized)',
    covariate_1082: 'Proportion of liver cancer due to hepatitis C (Age Standardized)',
    covariate_1083: 'Proportion of liver cancer due to other causes (Age Standardized)',
    covariate_1084: 'Seroprevalence of anti-HAV (IgG)',
    covariate_1085: 'Seroprevalence of anti-HEV (IgG)',
    covariate_1086: 'Major depressive disorder',
    covariate_1087: 'Proportion of population involved in agricultural activities',
    covariate_1089: 'Health expenditure (per capita)',
    covariate_1090: 'Risk of selfharm due to major depressive disorder',
    covariate_1093: 'Fraction of OOP Health Expenditure',
    covariate_1097: 'Universal health coverage',
    covariate_1098: 'Maternal alcohol consumption during pregnancy (proportion)',
    covariate_1099: 'Healthcare access and quality index',
    covariate_1100: 'Age-standardized proportion adult underweight',
    covariate_1102: 'ORS (oral rehydration)',
    covariate_1103: 'Antibiotics for LRI',
    covariate_1105: 'Antibiotics for diarrhea',
    covariate_1106: 'Live births (by sex)',
    covariate_1107: 'Age-standardized melanoma',
    covariate_1108: 'Measles Vaccine Coverage 2 doses (proportion)',
    covariate_1110: 'Schisto cumulative treatments',
    covariate_1111: 'Health worker density',
    covariate_1113: 'Iron energy unadjusted (mg)',
    covariate_1123: 'Poultry energy unadjusted (g)',
    covariate_1129: 'Malaria PfPR_MAP',
    covariate_1130: 'Malaria incidence_MAP',
    covariate_1131: 'Antimalarial effective treatment ratio_MAP',
    covariate_1132: 'Antimalarial effective treatment_MAP',
    covariate_1136: 'Mean birth weight',
    covariate_1140: 'Mean hemoglobin concentration (age-standardized)',
    covariate_1142:
        'Age-standardized prevalence of cocaine dependence in women of reproductive-age',
    covariate_1144: 'Age-standardized prevalence of opioid dependence in women of reproductive age',
    covariate_1145:
        'Age-standardized prevalence of cannabis dependence in women of reproductive age',
    covariate_1147: 'Rubella Vaccine Coverage (Proportion)',
    covariate_1148: 'Tuberculosis infection risk-weighted prevalence (age-standardized)',
    covariate_1149: 'Presenting vision impairment',
    covariate_1150: '10-year lag distributed energy per capita',
    covariate_1153: 'Folic acid unadjusted (ug)',
    covariate_1154: 'Smooth outphase of leaded gasoline',
    covariate_1155: 'No access to handwashing facility',
    covariate_1156: 'Residential radon',
    covariate_1157: 'Lead exposure',
    covariate_1158: 'Discontinued breastfeeding SEV',
    covariate_1159: 'Zinc deficiency',
    covariate_1162: 'Diet high in trans fatty acids',
    covariate_1163: 'Diet high in sodium',
    covariate_1165: 'Tuberculosis prevalence (age-standardized)',
    covariate_1166: 'Low bone mineral density',
    covariate_1168: 'Age-standardized bone mineral density among population age 60+ years',
    covariate_1169: 'Malnutrition Shock log-transformed mortality rate',
    covariate_1170: 'Malnutrition Shock mortality rate',
    covariate_1171: 'Mean war mortality rate in the previous ten years',
    covariate_1181: 'Alcohol abstainer proportion, age-standardized',
    covariate_1182: 'Log-transformed age-standardized SEV scalar for both sexes combined: TB',
    covariate_1183: 'Secondhand smoke',
    covariate_1185: 'Asbestos consumption (metric tons per year per capita)',
    covariate_1186: 'Visceral leishmaniasis incidence',
    covariate_1187: 'Homicide rate (sex-specific)',
    covariate_1190: 'Non-partner lifetime prevalence of sexual violence (female-only)',
    covariate_1191: 'All age underweight',
    covariate_1193: 'Zinc treatment for diarrhea',
    covariate_1194: 'Fortification standard',
    covariate_1195: 'Fortification standard including folic acid',
    covariate_1196: 'Adult HIV crude death rate',
    covariate_1197: 'Demand for contraception satisfied with modern methods',
    covariate_1198: 'Demand for contraception satisfied with modern methods, by age',
    covariate_1199: 'Long-term Population-weighted mean temperature',
    covariate_1200: 'Polio 3-dose coverage (proportion)',
    covariate_1201: 'Hepatitis B 3-dose coverage (proportion)',
    covariate_1207: 'Composite fortification standard and folic acid inclusion',
    covariate_1208: 'Intravenous drug use (proportion by age)',
    covariate_1209: 'Intravenous drug use (age-standardized proportion)',
    covariate_1211: 'Alcohol consumption, age standardized, in grams per day',
    covariate_1212: 'Alcohol drinker proportion, age-standardized',
    covariate_1216: 'Proportion of liver cancer due to MASH (Age Standardized)',
    covariate_1217: 'Proportion of cirrhosis due to MASH',
    covariate_1218: 'Muslim Religion (proportion of population)',
    covariate_1222: 'TB strain prevalence-weighted transmission RR',
    covariate_1227: 'Short gestation SEV (all ages, by sex)',
    covariate_1229: 'Age- and sex-specific SEV for Child underweight',
    covariate_1230: 'Age-standardized SEV for Child underweight',
    covariate_1231: 'Age- and sex-specific SEV for Child stunting',
    covariate_1232: 'Age-standardized SEV for Child stunting',
    covariate_1233: 'Age- and sex-specific SEV for Child wasting',
    covariate_1234: 'Age-standardized SEV for Child wasting',
    covariate_1235: 'Low birth weight SEV (all ages, by sex)',
    covariate_1240: 'Adult HIV death rate both sexes',
    covariate_1241: 'Fortification standard including iron',
    covariate_1242: 'Composite fortification standard and iron inclusion',
    covariate_1243: 'Pelvic inflammatory disease age-standardized prevalence',
    covariate_1244: 'Pelvic inflammatory disease all-age prevalence',
    covariate_1245: 'MASLD/MASH prevalence',
    covariate_1246: 'Hepatitis B 3-dose coverage (proportion), lagged 5 years',
    covariate_1247: 'Hepatitis B 3-dose coverage (proportion), lagged 10 years',
    covariate_1248: 'Interaction between SDI and 2+4 wheeled vehicles per capita',
    covariate_1249: 'Age-standardized death rate of diabetes (0-15 years) (per 100,000)',
    covariate_1250: 'Age- and sex-specific SEV for Alcohol use',
    covariate_1251: 'Age-standardized SEV for Alcohol use',
    covariate_1252: 'Underweight women of reproductive age',
    covariate_1253: 'Underweight women, age specific',
    covariate_1255: 'Opioids per million population per day',
    covariate_1831: 'Log-transformed SEV scalar: Group I',
    covariate_1832: 'Log-transformed SEV scalar: Drug-Sus TB',
    covariate_1833: 'Log-transformed SEV scalar: MDR-TB',
    covariate_1834: 'Log-transformed SEV scalar: XDR-TB',
    covariate_1835: 'Log-transformed SEV scalar: HIV',
    covariate_1836: 'Log-transformed SEV scalar: Drug-Sus HIV-TB',
    covariate_1837: 'Log-transformed SEV scalar: MDR-HIV-TB',
    covariate_1838: 'Log-transformed SEV scalar: XDR-HIV-TB',
    covariate_1839: 'Log-transformed SEV scalar: meningitis_pneumo',
    covariate_1840: 'Log-transformed SEV scalar: meningitis_hib',
    covariate_1841: 'Log-transformed SEV scalar: meningitis_meningo',
    covariate_1842: 'Log-transformed SEV scalar: meningitis_other',
    covariate_1843: 'Log-transformed SEV scalar: Encepha',
    covariate_1846: 'Log-transformed SEV scalar: NN Enceph',
    covariate_1847: 'Log-transformed SEV scalar: NN Sepsis',
    covariate_1848: 'Log-transformed SEV scalar: NN Hemol',
    covariate_1849: 'Log-transformed SEV scalar: Oth NN',
    covariate_1860: 'Log-transformed SEV scalar: NCD',
    covariate_1863: 'Log-transformed SEV scalar: Lymphoma',
    covariate_1864: 'Log-transformed SEV scalar: Myeloma',
    covariate_1865: 'Log-transformed SEV scalar: ALL',
    covariate_1866: 'Log-transformed SEV scalar: CLL',
    covariate_1867: 'Log-transformed SEV scalar: AML',
    covariate_1868: 'Log-transformed SEV scalar: CML',
    covariate_1869: 'Log-transformed SEV scalar: Oth Leukemia',
    covariate_1872: 'Log-transformed SEV scalar: Oth CMP',
    covariate_1874: 'Log-transformed SEV scalar: PUD',
    covariate_1875: 'Log-transformed SEV scalar: Gall Bile',
    covariate_1876: "Log-transformed SEV scalar: Alzheimer's",
    covariate_1878: 'Log-transformed SEV scalar: MS',
    covariate_1892: 'Log-transformed SEV scalar: Rheu Arth',
    covariate_1893: 'Log-transformed SEV scalar: Glaucoma',
    covariate_1894: 'Log-transformed SEV scalar: Macular',
    covariate_1895: 'Log-transformed SEV scalar: Injuries',
    covariate_1896: 'Log-transformed SEV scalar: Self Fire',
    covariate_1897: 'Log-transformed SEV scalar: Self Other',
    covariate_1898: 'Log-transformed SEV scalar: Sex Viol',
    covariate_1899: 'Log-transformed age-standardized SEV scalar: Group I',
    covariate_1900: 'Log-transformed age-standardized SEV scalar: Drug-Sus TB',
    covariate_1901: 'Log-transformed age-standardized SEV scalar: MDR-TB',
    covariate_1902: 'Log-transformed age-standardized SEV scalar: XDR-TB',
    covariate_1903: 'Log-transformed age-standardized SEV scalar: HIV',
    covariate_1904: 'Log-transformed age-standardized SEV scalar: Drug-Sus HIV-TB',
    covariate_1905: 'Log-transformed age-standardized SEV scalar: MDR-HIV-TB',
    covariate_1906: 'Log-transformed age-standardized SEV scalar: XDR-HIV-TB',
    covariate_1907: 'Log-transformed age-standardized SEV scalar: Meningitis',
    covariate_1908: 'Log-transformed age-standardized SEV scalar: meningitis_pneumo',
    covariate_1909: 'Log-transformed age-standardized SEV scalar: meningitis_hib',
    covariate_1910: 'Log-transformed age-standardized SEV scalar: meningitis_meningo',
    covariate_1911: 'Log-transformed age-standardized SEV scalar: meningitis_other',
    covariate_1912: 'Log-transformed age-standardized SEV scalar: Encepha',
    covariate_1917: 'Log-transformed age-standardized SEV scalar: NN Enceph',
    covariate_1918: 'Log-transformed age-standardized SEV scalar: NN Sepsis',
    covariate_1919: 'Log-transformed age-standardized SEV scalar: NN Hemol',
    covariate_1920: 'Log-transformed age-standardized SEV scalar: Oth NN',
    covariate_1934: 'Log-transformed age-standardized SEV scalar: Lymphoma',
    covariate_1935: 'Log-transformed age-standardized SEV scalar: Myeloma',
    covariate_1936: 'Log-transformed age-standardized SEV scalar: ALL',
    covariate_1937: 'Log-transformed age-standardized SEV scalar: CLL',
    covariate_1938: 'Log-transformed age-standardized SEV scalar: AML',
    covariate_1939: 'Log-transformed age-standardized SEV scalar: CML',
    covariate_1940: 'Log-transformed age-standardized SEV scalar: Oth Leukemia',
    covariate_1943: 'Log-transformed age-standardized SEV scalar: Oth CMP',
    covariate_1945: 'Log-transformed age-standardized SEV scalar: PUD',
    covariate_1946: 'Log-transformed age-standardized SEV scalar: Gall Bile',
    covariate_1947: "Log-transformed age-standardized SEV scalar: Alzheimer's",
    covariate_1949: 'Log-transformed age-standardized SEV scalar: MS',
    covariate_1963: 'Log-transformed age-standardized SEV scalar: Rheu Arth',
    covariate_1964: 'Log-transformed age-standardized SEV scalar: Glaucoma',
    covariate_1965: 'Log-transformed age-standardized SEV scalar: Macular',
    covariate_1966: 'Log-transformed age-standardized SEV scalar: SIDS',
    covariate_1967: 'Log-transformed age-standardized SEV scalar: Injuries',
    covariate_1968: 'Log-transformed age-standardized SEV scalar: Self Fire',
    covariate_1969: 'Log-transformed age-standardized SEV scalar: Self Other',
    covariate_1970: 'Log-transformed age-standardized SEV scalar: Sex Viol',
    covariate_1971: 'Opioids per million population per day (5 year lag)',
    covariate_1972: 'Opioids per million population per day (10 year lag)',
    covariate_1973: 'Occupation Professionals',
    covariate_1974: 'Health Industry Workers',
    covariate_1975: 'Education (years per capita) aggregated by age (15+) and sex',
    covariate_1976: 'Underweight, age and sex specific',
    covariate_1977: 'Total Physical Activity (MET-min/week), Age-specific',
    covariate_1978: 'Total Physical Activity (MET-min/week), Age-standardized',
    covariate_1980: 'Bacille Calmette-Guerin (BCG) vaccine coverage (proportion)',
    covariate_1981: 'Hepatitis B vaccine coverage (proportion), aged through time',
    covariate_1982: 'Adolescent Birth Rates (10 - 19 years of age)',
    covariate_1984: 'Log total health expenditure per capita',
    covariate_1987: 'Pigs raised in extensive agricultural systems per capita',
    covariate_1988: 'Pigs raised in semi-extensive agricultural systems per capita',
    covariate_1989: 'Pigs raised in intensive/industrial agricultural systems per capita',
    covariate_1992: 'Mean hemoglobin, age sex specific',
    covariate_1993: 'Physicians per capita',
    covariate_1994: 'Nurses and Midwives per capita',
    covariate_1995: 'Pharmacists per capita',
    covariate_1996: 'HIV mortality rate',
    covariate_1998: 'Medical schools',
    covariate_1999: 'Dentists per capita',
    covariate_2002: 'Log-transformed coal production (per capita)',
    covariate_2003: 'Systolic blood pressure (mmHg) [US R/E]',
    covariate_2004: 'Low-density lipoprotein (mmol/L) [US R/E]',
    covariate_2005: 'Mean BMI (kg/m^2) [US R/E]',
    covariate_2006: 'Education (years per capita) [US R/E]',
    covariate_2007: 'LDI (I$ per capita) [US R/E]',
    covariate_2008: 'Fasting plasma glucose [US R/E]',
    covariate_2009: 'Total physical activity (MET-min/week), age-specific [US R/E]',
    covariate_2010: 'Total physical activity (MET-min/week), age-standardized [US R/E]',
    covariate_2011: 'Alcohol (liters per capita) [US R/E]',
    covariate_2012: 'Smoking prevalence [US R/E]',
    covariate_2013: 'Outdoor Air Pollution (PM 2.5) [US R/E]',
    covariate_2014: 'Fruits, unadjusted (g) [US R/E]',
    covariate_2015: 'Vegetables, unadjusted (g) [US R/E]',
    covariate_2016: 'Proportion of the population with at least 6 years of education',
    covariate_2017: 'Proportion of the population with at least 12 years of education',
    covariate_2018: 'Proportion of the population with at least 15 years of education',
    covariate_2019: 'Education Absolute Inequality (AAID)',
    covariate_2020: 'Education Relative Inequality (Gini)',
    covariate_2021:
        'Proportion of the population with at least 6 years of education, age-standardized',
    covariate_2022:
        'Proportion of the population with at least 12 years of education, age-standardized',
    covariate_2023:
        'Proportion of the population with at least 15 years of education, age-standardized',
    covariate_2024: 'Education Absolute Inequality (AAID), age-standardized',
    covariate_2025: 'Education Relative Inequality (Gini), age-standardized',
    covariate_2026: 'Proportion of the population with at least 6 years of education, maternal',
    covariate_2027: 'Proportion of the population with at least 12 years of education, maternal',
    covariate_2028: 'Proportion of the population with at least 15 years of education, maternal',
    covariate_2029: 'Education Absolute Inequality (AAID), maternal',
    covariate_2030: 'Education Relative Inequality (Gini), maternal',
    covariate_2031: 'MMR due toe maternal hemorrhage',
    covariate_2032: 'MMR due to maternal hypertensive disorders ',
    covariate_2033: 'MMR due to abortion and miscarriage ',
    covariate_2034: 'MMR due to sepsis and other maternal infections',
    covariate_2035: 'MMR due to obstructed labor',
    covariate_2036: 'MMR due to ectopic pregnancy',
    covariate_2038: 'Age-standardized SEV for Unsafe water',
    covariate_2039: 'Age-standardized SEV for Unsafe sanitation',
    covariate_2040: 'Age- and sex-specific SEV for Handwashing',
    covariate_2041: 'Age-standardized SEV for Handwashing',
    covariate_2042: 'Age- and sex-specific SEV for Ambient particulate matter',
    covariate_2043: 'Age-standardized SEV for Ambient particulate matter',
    covariate_2044: 'Age- and sex-specific SEV for Household air pollution',
    covariate_2045: 'Age-standardized SEV for Household air pollution',
    covariate_2046: 'Age- and sex-specific SEV for Ozone',
    covariate_2047: 'Age-standardized SEV for Ozone',
    covariate_2048: 'Age- and sex-specific SEV for Radon',
    covariate_2049: 'Age-standardized SEV for Radon',
    covariate_2050: 'Age- and sex-specific SEV for Lead',
    covariate_2051: 'Age-standardized SEV for Lead',
    covariate_2052: 'Age- and sex-specific SEV for Occupational asbestos',
    covariate_2053: 'Age-standardized SEV for Occupational asbestos',
    covariate_2054: 'Age- and sex-specific SEV for Occupational arsenic',
    covariate_2055: 'Age-standardized SEV for Occupational arsenic',
    covariate_2056: 'Age- and sex-specific SEV for Occupational benzene',
    covariate_2057: 'Age-standardized SEV for Occupational benzene',
    covariate_2058: 'Age- and sex-specific SEV for Occupational beryllium',
    covariate_2059: 'Age-standardized SEV for Occupational beryllium',
    covariate_2060: 'Age- and sex-specific SEV for Occupational cadmium',
    covariate_2061: 'Age-standardized SEV for Occupational cadmium',
    covariate_2062: 'Age- and sex-specific SEV for Occupational chromium',
    covariate_2063: 'Age-standardized SEV for Occupational chromium',
    covariate_2064: 'Age- and sex-specific SEV for Occupational diesel',
    covariate_2065: 'Age-standardized SEV for Occupational diesel',
    covariate_2066: 'Age- and sex-specific SEV for Occupational formaldehyde',
    covariate_2067: 'Age-standardized SEV for Occupational formaldehyde',
    covariate_2068: 'Age- and sex-specific SEV for Occupational nickel',
    covariate_2069: 'Age-standardized SEV for Occupational nickel',
    covariate_2070: 'Age- and sex-specific SEV for Occupational PAH',
    covariate_2071: 'Age-standardized SEV for Occupational PAH',
    covariate_2072: 'Age- and sex-specific SEV for Occupational silica',
    covariate_2073: 'Age-standardized SEV for Occupational silica',
    covariate_2074: 'Age- and sex-specific SEV for Occupational sulfuric acid',
    covariate_2075: 'Age-standardized SEV for Occupational sulfuric acid',
    covariate_2076: 'Age- and sex-specific SEV for Occupational trichloroethylene',
    covariate_2077: 'Age-standardized SEV for Occupational trichloroethylene',
    covariate_2078: 'Age- and sex-specific SEV for Occupational asthmagens',
    covariate_2079: 'Age-standardized SEV for Occupational asthmagens',
    covariate_2080: 'Age- and sex-specific SEV for Occupational particulates',
    covariate_2081: 'Age-standardized SEV for Occupational particulates',
    covariate_2082: 'Age- and sex-specific SEV for Occupational noise',
    covariate_2083: 'Age-standardized SEV for Occupational noise',
    covariate_2086: 'Age- and sex-specific SEV for Occupational ergonomic',
    covariate_2087: 'Age-standardized SEV for Occupational ergonomic',
    covariate_2088: 'Age- and sex-specific SEV for Non-exclusive breastfeeding',
    covariate_2089: 'Age-standardized SEV for Non-exclusive breastfeeding',
    covariate_2090: 'Age- and sex-specific SEV for Discontinued breastfeeding',
    covariate_2091: 'Age-standardized SEV for Discontinued breastfeeding',
    covariate_2092: 'Age- and sex-specific SEV for Short gestation',
    covariate_2093: 'Age-standardized SEV for Short gestation',
    covariate_2094: 'Age- and sex-specific SEV for Low birth weight',
    covariate_2095: 'Age-standardized SEV for Low birth weight',
    covariate_2096: 'Age- and sex-specific SEV for Iron deficiency',
    covariate_2097: 'Age-standardized SEV for Iron deficiency',
    covariate_2098: 'Age- and sex-specific SEV for Vitamin A deficiency',
    covariate_2099: 'Age-standardized SEV for Vitamin A deficiency',
    covariate_2100: 'Age- and sex-specific SEV for Zinc deficiency',
    covariate_2101: 'Age-standardized SEV for Zinc deficiency',
    covariate_2102: 'Age- and sex-specific SEV for Smoking',
    covariate_2103: 'Age-standardized SEV for Smoking',
    covariate_2104: 'Age- and sex-specific SEV for Chewing tobacco',
    covariate_2105: 'Age-standardized SEV for Chewing tobacco',
    covariate_2106: 'Age- and sex-specific SEV for Secondhand smoke',
    covariate_2107: 'Age-standardized SEV for Secondhand smoke',
    covariate_2108: 'Age- and sex-specific SEV for Drug use',
    covariate_2109: 'Age-standardized SEV for Drug use',
    covariate_2110: 'Age- and sex-specific SEV for Low fruit',
    covariate_2111: 'Age-standardized SEV for Low fruit',
    covariate_2112: 'Age- and sex-specific SEV for Low vegetables',
    covariate_2113: 'Age-standardized SEV for Low vegetables',
    covariate_2114: 'Age- and sex-specific SEV for Low legumes',
    covariate_2115: 'Age-standardized SEV for Low legumes',
    covariate_2116: 'Age- and sex-specific SEV for Low whole grains',
    covariate_2117: 'Age-standardized SEV for Low whole grains',
    covariate_2118: 'Age- and sex-specific SEV for Low nuts and seeds',
    covariate_2119: 'Age-standardized SEV for Low nuts and seeds',
    covariate_2120: 'Age- and sex-specific SEV for Low milk',
    covariate_2121: 'Age-standardized SEV for Low milk',
    covariate_2122: 'Age- and sex-specific SEV for High red meat',
    covariate_2123: 'Age-standardized SEV for High red meat',
    covariate_2124: 'Age- and sex-specific SEV for High processed meat',
    covariate_2125: 'Age-standardized SEV for High processed meat',
    covariate_2126: 'Age- and sex-specific SEV for High sweetened beverages',
    covariate_2127: 'Age-standardized SEV for High sweetened beverages',
    covariate_2128: 'Age- and sex-specific SEV for Low fiber',
    covariate_2129: 'Age-standardized SEV for Low fiber',
    covariate_2130: 'Age- and sex-specific SEV for Low calcium',
    covariate_2131: 'Age-standardized SEV for Low calcium',
    covariate_2132: 'Age- and sex-specific SEV for Low omega-3',
    covariate_2133: 'Age-standardized SEV for Low omega-3',
    covariate_2134: 'Age- and sex-specific SEV for Low PUFA',
    covariate_2135: 'Age-standardized SEV for Low PUFA',
    covariate_2136: 'Age- and sex-specific SEV for High trans fat',
    covariate_2137: 'Age-standardized SEV for High trans fat',
    covariate_2138: 'Age- and sex-specific SEV for High sodium',
    covariate_2139: 'Age-standardized SEV for High sodium',
    covariate_2140: 'Age- and sex-specific SEV for Intimate partner violence',
    covariate_2141: 'Age-standardized SEV for Intimate partner violence',
    covariate_2142: 'Age- and sex-specific SEV for Childhood sexual abuse',
    covariate_2143: 'Age-standardized SEV for Childhood sexual abuse',
    covariate_2144: 'Age- and sex-specific SEV for Bullying',
    covariate_2145: 'Age-standardized SEV for Bullying',
    covariate_2148: 'Age- and sex-specific SEV for Low physical activity',
    covariate_2149: 'Age-standardized SEV for Low physical activity',
    covariate_2150: 'Age- and sex-specific SEV for High fasting plasma glucose',
    covariate_2151: 'Age-standardized SEV for High fasting plasma glucose',
    covariate_2152: 'Age- and sex-specific SEV for High LDL',
    covariate_2153: 'Age-standardized SEV for High LDL',
    covariate_2154: 'Age- and sex-specific SEV for High blood pressure',
    covariate_2155: 'Age-standardized SEV for High blood pressure',
    covariate_2156: 'Age- and sex-specific SEV for High body-mass index',
    covariate_2157: 'Age-standardized SEV for High body-mass index',
    covariate_2158: 'Age- and sex-specific SEV for Low bone mineral density',
    covariate_2159: 'Age-standardized SEV for Low bone mineral density',
    covariate_2160: 'Age- and sex-specific SEV for Impaired kidney function',
    covariate_2161: 'Age-standardized SEV for Impaired kidney function',
    covariate_2179: 'Log-transformed age-standardized SEV scalar: Obst Labor',
    covariate_2180: 'Log-transformed SEV scalar: Obst Labor',
    covariate_2181: 'Log-transformed age-standardized SEV scalar: Ectopic Preg',
    covariate_2182: 'Log-transformed SEV scalar: Ectopic Preg',
    covariate_2187: 'Log-transformed age-standardized SEV scalar: Neonatal',
    covariate_2188: 'Log-transformed SEV scalar: Neonatal',
    covariate_2190: 'Log-transformed age-standardized SEV scalar: Liver C MASH',
    covariate_2191: 'Log-transformed SEV scalar: Liver C MASH',
    covariate_2192: 'Log-transformed age-standardized SEV scalar: Sub Hem',
    covariate_2193: 'Log-transformed SEV scalar: Sub Hem',
    covariate_2194: 'Log-transformed age-standardized SEV scalar: Valvular',
    covariate_2195: 'Log-transformed SEV scalar: Valvular',
    covariate_2196: 'Log-transformed age-standardized SEV scalar: CAVD',
    covariate_2197: 'Log-transformed SEV scalar: CAVD',
    covariate_2198: 'Log-transformed age-standardized SEV scalar: Upper Digest',
    covariate_2199: 'Log-transformed SEV scalar: Upper Digest',
    covariate_2207: 'Log-transformed age-standardized SEV scalar: Blindness',
    covariate_2208: 'Log-transformed SEV scalar: Blindness',
    covariate_2211: 'Log-transformed age-standardized SEV scalar: Inj Pois CO',
    covariate_2212: 'Log-transformed SEV scalar: Inj Pois CO',
    covariate_2213: 'Log-transformed age-standardized SEV scalar: Inj Pois Oth',
    covariate_2214: 'Log-transformed SEV scalar: Inj Pois Oth',
    covariate_2215: 'Log-transformed age-standardized SEV scalar: Heat + cold',
    covariate_2216: 'Log-transformed SEV scalar: Heat + cold',
    covariate_2235: 'Log-transformed age-standardized SEV scalar: Mat HTN',
    covariate_2239: 'Log-transformed age-standardized SEV scalar: Mat Indir',
    covariate_2240: 'Log-transformed age-standardized SEV scalar: Mat Late',
    covariate_2241: 'Log-transformed age-standardized SEV scalar: Oth Mat',
    covariate_2242: 'Log-transformed age-standardized SEV scalar: NCD',
    covariate_2244: 'Log-transformed age-standardized SEV scalar: Anxiety',
    covariate_2247: 'Log-transformed age-standardized SEV scalar: Disaster',
    covariate_2248: 'Log-transformed age-standardized SEV scalar: Mat HIV',
    covariate_2249: 'Log-transformed age-standardized SEV scalar: Mat Abort',
    covariate_2250: 'Log-transformed SEV scalar: Mat Abort',
    covariate_2264: 'Proportion of the population with 0 years of education',
    covariate_2265: 'Proportion of the population with 0 years of education, maternal',
    covariate_2266: 'Proportion of the population with 0 years of education, age-standardized',
    covariate_2267: 'Stillbirth to live birth ratio',
    covariate_2268: 'Proportion PNN pop aged 1-5 mo',
    covariate_2269: 'Proportion 1-4 pop aged 1 year',
    covariate_2270: 'Gallup: Negative Experience Index',
    covariate_2271: 'Hemoglobin C (sickle type C) trait',
    covariate_2272: 'Hemoglobin S (sickle type S) trait',
    covariate_2276: 'Proportion of the population working in mining with 20-year lag',
    covariate_2277: 'Gold production (kg) per capita, smoothed with 20-year lag',
    covariate_2279: 'Diabetes Fasting Plasma Glucose (mmol/L), by age',
    covariate_2282: 'Hepatitis A Seroprevalence (anti-HAV) age standardized',
    covariate_2283: 'Hepatitis B Seroprevalence (HBsAg) age standardized',
    covariate_2284: 'Hepatitis C Seroprevalence (anti-HCV) age standardized',
    covariate_2285: 'Hepatitis E Seroprevalence (anti-HEV) age standardized',
    covariate_2286: 'HPV1 coverage (proportion)',
    covariate_2287: 'BAC law general population (quartile)',
    covariate_2288: 'BAC law youth drivers (quartile)',
    covariate_2289: 'BAC law  professional drivers (quartile)',
    covariate_2290: 'Speed limit law urban (quartile)',
    covariate_2291: 'Speed limit law rural (quartile)',
    covariate_2293: 'Seat belt frequency (%)',
    covariate_2294: 'MenAfriVac campaign ever/never',
    covariate_2295: 'Time since last mass MenAfriVac campaign',
    covariate_2296: 'Time since any MenAfriVac campaign',
    covariate_2297: 'Liters of alcohol consumed per capita',
    covariate_2298: "Live births (by child's sex and maternal age)",
    covariate_2299: '12-month non-partner sexual violence',
    covariate_2300: 'Population 15 to 30 males (proportion)',
    covariate_2302: 'Max Trachoma Population at risk',
    covariate_2304: 'Schistosomiasis Prevalence Results',
    covariate_2305: 'WHO STH MDA Coverage',
    covariate_2307: 'BCG lagged five year coverage (proportion)',
    covariate_2308: 'DTP3 lagged five year coverage (proportion)',
    covariate_2309: 'MCV1 lagged five year coverage (proportion)',
    covariate_2310: 'MCV2 lagged five year coverage (proportion)',
    covariate_2311: 'Polio3 lagged five year coverage (proportion)',
    covariate_2312: 'RCV1 lagged five year coverage (proportion)',
    covariate_2313: 'Hib3 lagged five year coverage (proportion)',
    covariate_2314: 'PCV3 lagged five year coverage (proportion)',
    covariate_2315: 'RotaC lagged five year coverage (proportion)',
    covariate_2316: 'HepB3 lagged five year coverage (proportion)',
    covariate_2317: 'Vitamin A supplementation (age-specific)',
    covariate_2318: 'Proportion of population vulnerable to venomous snakebites',
    covariate_2319: 'INJ time',
    covariate_2321: 'Mean number of venomous snake species',
    covariate_2323: 'TFR U20 [US R/E]',
    covariate_2324: 'Dengue all-age CSMR',
    covariate_2325: 'Education (years per capita) aggregated by age(15+) and sex [US R/E]',
    covariate_2326: 'Age- and sex-specific SEV for High temperature',
    covariate_2327: 'Age- and sex-specific SEV for Low temperature',
    covariate_2328: 'Age-standardized SEV for High temperature',
    covariate_2329: 'Age-standardized SEV for Low temperature',
    covariate_2330: 'HPV2 coverage (proportion)',
    covariate_2331: 'Inpatient utilization envelope',
    covariate_2332: 'Opioid substitution therapy (OST) treatment coverage',
    covariate_2333: 'Government Spending on Health',
    covariate_2334: 'Liters of alcohol consumed per capita by age and sex',
    covariate_2335: 'Total government spending',
    covariate_2336: 'Chronic Hepatitis C age standardized',
    covariate_2338: 'High risk MenAfriVac coverage (proportion)',
    covariate_2339: 'Vaccine adjusted HbSAg serporevalence age standardized',
    covariate_2341: 'Solar Radiation (downwards)',
    covariate_2342:
        'Hib3 transformed: population-level coverage, including indirect effects (proportion)',
    covariate_2343: 'Age-standardized daily smoking prevalence, both sexes',
    covariate_2345: 'Log-Transformed SEV scalar: Oth Cirr',
    covariate_2346: 'Log-Transformed age-standardized SEV scalar: Oth Cirr',
    covariate_2347: 'Log-Transformed SEV scalar: Burkitt',
    covariate_2348: 'Log-Transformed age-standardized SEV scalar: Burkitt',
    covariate_2349: 'Log-Transformed SEV scalar: Oth Lymphoma',
    covariate_2350: 'Log-Transformed age-standardized SEV scalar: Oth Lymphoma',
    covariate_2351: 'Log-Transformed SEV scalar: Osteoarth Hip',
    covariate_2352: 'Log-Transformed age-standardized SEV scalar: Osteoarth Hip',
    covariate_2353: 'Log-Transformed SEV scalar: Osteoarth Knee',
    covariate_2354: 'Log-Transformed age-standardized SEV scalar: Osteoarth Knee',
    covariate_2355: 'Ascariasis Prevalence',
    covariate_2356: 'Custom Age-standardized and sex-specific SEV for Alcohol use',
    covariate_2381: 'Caesarean Section',
    covariate_2384: 'Proportion in correctional facility',
    covariate_2387: 'Alcohol availability per capita, smoothed',
    covariate_2391: 'Tobacco stores per capita, smoothed',
    covariate_2392: 'Proportion with BA+',
    covariate_2394: 'Proportion with HS+',
    covariate_2396: 'Proportion foreign-born',
    covariate_2397: 'Proportion foreign-born age 25+',
    covariate_2400: 'Income per capita',
    covariate_2402: 'MDs per capita',
    covariate_2404: 'Median household income',
    covariate_2405: 'Median property value',
    covariate_2406: 'Log of population density',
    covariate_2407: 'Population density',
    covariate_2408: 'Proportion in college',
    covariate_2410: 'Proportion in poverty age 25+',
    covariate_2412: 'Proportion land in reservations',
    covariate_2413: 'Proportion land in federal reservations',
    covariate_2414: 'Proportion land in state reservations',
    covariate_2422: 'Proportion rural',
    covariate_2423: 'Proportion unemployed age 16+',
    covariate_2424: 'Proportion unemployed age 25+',
    covariate_2425: 'Proportion with health insurance age 25+',
    covariate_2441: 'DTP3 lagged five year coverage, COVID-inclusive (proportion)',
    covariate_2442: 'MCV1 lagged five year coverage, COVID-inclusive (proportion)',
    covariate_2446: 'Hib3 lagged five year coverage, COVID-inclusive (proportion)',
    covariate_2447: 'PCV3 lagged five year coverage, COVID-inclusive (proportion)',
    covariate_2448: 'RotaC lagged five year coverage, COVID-inclusive (proportion)',
    covariate_2452: 'Hepatitis B vaccine coverage (proportion), aged through time, COVID-inclusive',
    covariate_2511: 'K-12 spending per student',
    covariate_2514: 'Proportion of owner-occupied homes',
    covariate_2516: 'Proportion in poverty',
    covariate_2517: 'Probability of Homozygous sickle cell disease at birth (SS)',
    covariate_2518: 'Probability of Hemoglobin SC disease at birth',
    covariate_2521:
        'Probability of  Homozygous sickle cell disease (SS) and G6PD deficiency at birth',
    covariate_2522: 'Probability of Hemoglobin SC disease (SC) and G6PD deficiency at birth',
    covariate_2523: 'Probability of G6PD deficiency at birth',
    covariate_2525: 'Domestic health expenditure (per capita)',
    covariate_2528: 'Proportion non-Hispanic AIAN age 25+',
    covariate_2529: 'Proportion non-Hispanic API age 25+',
    covariate_2530: 'Proportion non-Hispanic Black age 25+',
    covariate_2531: 'Proportion non-Hispanic White age 25+',
    covariate_2532: 'Proportion Hispanic age 25+',
    covariate_2533: 'Age-specific cohort cumulative fertility (CCF)',
    covariate_2536: 'Mobility during COVID-19 pandemic',
    covariate_2537: 'Mask use',
    covariate_2550: 'Major depressive disorder (age-standardized)',
    covariate_2582: 'Log-transformed SEV scalar: HIV/AIDS+STIs',
    covariate_2583: 'Log-transformed age-standardized SEV scalar: HIV/AIDS+STIs',
    covariate_2595: 'Normal Hemoglobin',
    covariate_2598: 'COVID-19 age-standardized death rate',
};
